import React from 'react'
import classNames from 'classnames'
import { IconLayoutSidebarLeftCollapse } from '@tabler/icons-react'

import { Button } from '@/components/buttons/Button'
import { BaltoLogo } from '@/components/BaltoLogo'
import { InteractiveTooltip } from '@/components/tooltips/InteractiveTooltip'
import { useTheme } from '@/utils/hooks/useTheme'

export const SidebarHeader = ({
  organizationName,
  branding,
  sidebarCollapsed,
  handleToggleSidebarCollapsed,
}) => {
  const theme = useTheme()
  const { loading, customBranding, imageCache } = branding
  const { iconDarkUrl, iconLightUrl } = customBranding
  const shouldShowCustomLogo =
    theme === 'dark' ? iconDarkUrl || iconLightUrl : iconLightUrl || iconDarkUrl
  const customLogoUrl = `${shouldShowCustomLogo}?${imageCache}`
  const BaltoCompanyName = 'Balto'

  const logo = (
    <div
      className={classNames({
        'balto-sidebar__brand-logo': shouldShowCustomLogo,
        'balto-sidebar__balto-logo': !shouldShowCustomLogo,
      })}
    >
      {shouldShowCustomLogo ? (
        <img
          src={customLogoUrl}
          alt="App Logo"
          className="custom-app-logo"
          data-testid="custom-app-logo"
        />
      ) : (
        <BaltoLogo
          height={24}
          width={24}
          fill="var(--color-text-on-fill)"
          data-testid="balto-logo"
        />
      )}
    </div>
  )

  if (sidebarCollapsed) {
    return (
      <header className="balto-sidebar__header">
        {/* The logo is the expand button when collapsed. */}
        <InteractiveTooltip placement="right" content="Expand sidebar">
          <button
            type="button"
            className="balto-sidebar__expand-logo"
            onClick={handleToggleSidebarCollapsed}
            aria-label="Expand sidebar"
            data-testid="collapse-sidebar"
          >
            {logo}
          </button>
        </InteractiveTooltip>
      </header>
    )
  }

  return (
    <header className="balto-sidebar__header">
      <div className="balto-sidebar__brand">
        <InteractiveTooltip placement="bottom-start" content="Powered by Balto">
          {logo}
        </InteractiveTooltip>
        <div className="balto-sidebar__brand-name">
          <div className="text-overflow">
            {loading ? '' : customBranding.customBrandingDisplayName || BaltoCompanyName}
          </div>
          <div className="organization-name text-overflow">{organizationName}</div>
        </div>
      </div>
      <div className="balto-sidebar__header-actions">
        {/* The notification bell + Agent Assist launcher live in the footer
            now (SidebarFooter); the header keeps only the collapse toggle. */}
        <Button
          basic
          small
          square
          onClick={handleToggleSidebarCollapsed}
          data-testid="collapse-sidebar"
          aria-label="Collapse sidebar"
          tooltip="Collapse sidebar"
          tooltipProps={{ placement: 'bottom' }}
        >
          <IconLayoutSidebarLeftCollapse />
        </Button>
      </div>
    </header>
  )
}
